import {blurexamples} from '@/lib/config'

export default function getBlurHash() {

    //choose one item from the array at random and return it
    return blurexamples[Math.floor(Math.random() * blurexamples?.length)];
    
}